import { defineStore } from 'pinia';
import { userApiService } from 'src/services';
import { useSettingStore } from 'src/store/main';

export const useUserFontSizeStore = defineStore('user_font_size_store', {
  state: () => ({
    font_size: 'medium' as string,
    font_size_key: 'USER_FONT_SIZE',
    font_size_options: [
      { label: 'small', value: 'small' },
      { label: 'medium', value: 'medium' },
      { label: 'large', value: 'large' },
    ],
  }),
  getters: {
    getFontSize(state) {
      return state.font_size;
    },
  },
  actions: {
    async initFontSize() {
      await this.getFontSizeValue();
      this.setAppFontSize();
    },

    setAppFontSize() {
      const prefix = 'font-size-';
      const removeClassNameList = this.font_size_options.filter(
        (v: any) => v.value.indexOf(this.font_size) === -1,
      );

      const className = prefix + this.font_size;
      document.body.classList.add(className);

      Array.from(removeClassNameList).forEach((item: any) => {
        const className = prefix + item.value;
        document.body.classList.remove(className);
      });
    },

    async getFontSizeValue() {
      try {
        const settings_store = useSettingStore();

        const font_size = await settings_store.getSetting(this.font_size_key);
        if (font_size) {
          this.font_size = font_size;
          return;
        }

        const response = await settings_store.fetchSettingFromServer(
          this.font_size_key,
        );

        if (!response) {
          return;
        }
        const fontSizeOption = this.font_size_options.filter(
          (v: any) => v.value.indexOf(response) > -1,
        );
        if (fontSizeOption.length === 0) {
          return;
        }
        this.font_size = response;
      } catch (err) {
        logError('something went wrong while getFontSizeValue', err);
      }
    },

    saveFontSizeValue() {
      try {
        const settings_store = useSettingStore();
        settings_store.updateSetting(this.font_size_key, this.font_size);
      } catch (err) {
        logError('something went wrong while saveFontSizeValue', err);
      }
    },
  },
});
